(function () {
  'use strict';

  angular
    .module('AcaApp')
    .directive('ngRotate', directive);

  function directive() {
    var dir = {
      restrict: 'A',
      link: link
    };

    return dir;
  }

  function link($scope, element, attrs) {
    var expression = attrs.rotate;

    var degrees = attrs.degrees;

    $scope.$watch(expression, function (newValue, oldValue) {
      if (newValue) {
        element
          .css('transform', 'rotate(' + degrees + 'deg)');
      } else {
        element
          .css('transform', '');
      }
    });
  }
})();